import axios from "axios";
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { API } from "service/Interceptor";
import { applyProject } from "service/apiUrl";

const initialState = {
  isLoading: false,
  hasError: false,
  jobs: {},
};

export const createJob = createAsyncThunk(
  "jobs/create-job",
  async (payload) => {
    try {
      const res = await axios.post("post", payload);
      return res.data;
    } catch (error) {
      console.log(error);
    }
  }
);

export const getJobListing = createAsyncThunk("jobs/get-job", async () => {
  try {
    const res = await axios.get("get");
    return res.data;
  } catch (error) {
    console.log(error);
  }
});

export const applyJob = createAsyncThunk(
  "jobs/apply-job",
  async (projectId) => {
    try {
      const res = await API.post(`${applyProject}?jobId=${projectId}`);
      return res.data;
    } catch (error) {
      console.log(error);
    }
  }
);

const jobSlice = createSlice({
  name: "jobs",
  initialState,
  extraReducers: (builder) => {
    builder
      .addCase(createJob.pending, (state, action) => {
        state.isLoading = true;
        state.hasError = false;
      })
      .addCase(createJob.fulfilled, (state, action) => {
        state.isLoading = false;
        state.hasError = false;
      })
      .addCase(createJob.rejected, (state, action) => {
        state.isLoading = false;
        state.hasError = true;
      })
      .addCase(getJobListing.pending, (state, action) => {
        state.isLoading = true;
        state.hasError = false;
      })
      .addCase(getJobListing.fulfilled, (state, action) => {
        state.isLoading = false;
        state.hasError = false;
      })
      .addCase(getJobListing.rejected, (state, action) => {
        state.isLoading = false;
        state.hasError = true;
      });
  },
});

export default jobSlice.reducer;
